export default "__VITE_ASSET__DOPHhhGl__"